import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import mockUsersData from '../data/mockUsers.json';
import { storageService } from '../services/storageService';
import { ROLES } from '../utils/permissions';

const AuthContext = createContext(null);
const USERS_KEY = 'crm_users';

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = localStorage.getItem('crm_user');
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                if (parsedUser?.username && parsedUser.role && parsedUser.id && Object.values(ROLES).includes(parsedUser.role)) {
                     console.log("AuthContext Load: Setting user from storage:", parsedUser);
                    setUser(parsedUser);
                    setIsAuthenticated(true);
                } else {
                    console.warn("AuthContext Load: Invalid user data or role in storage.");
                    localStorage.removeItem('crm_user');
                }
            } catch (error) { console.error("AuthContext Load: Error parsing user:", error); localStorage.removeItem('crm_user'); }
        }
    }, []);

    const login = (username, password) => {
        const currentUsers = storageService.getItems(USERS_KEY, mockUsersData);
        const foundUser = currentUsers.find(u => u.username === username && u.password === password); // MOCK LOGIN

        if (foundUser && Object.values(ROLES).includes(foundUser.role)) {
            const userData = { username: foundUser.username, role: foundUser.role, id: foundUser.id };
            console.log("Login Success: Setting user:", userData);
            setUser(userData);
            setIsAuthenticated(true);
            localStorage.setItem('crm_user', JSON.stringify(userData));
            navigate('/dashboard');
            return true;
        }
        console.error(`Login failed for username: ${username}. User found: ${!!foundUser}, Role valid: ${Object.values(ROLES).includes(foundUser?.role)}`);
        return false;
    };

    const logout = () => {
        console.log("Logging out user");
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('crm_user'); // Clear user from storage
        navigate('/login');
    };

    const value = { user, isAuthenticated, login, logout };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);